module.exports = __webpack_public_path__ + "static/media/iphone_14_purple_plus.25d124be.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_purple_plus.jpeg
// module id = 2124
// module chunks = 0